import { useState, ReactNode } from "react";
import { ModalContext } from "./modalContext";
import { ModalType } from "../../types/ModalType.ts";

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [openModalType, setOpenModalType] = useState<ModalType | null>(null);

  const openModal = (type: ModalType) => {
    setOpenModalType(type);
  };

  const closeModal = () => {
    setOpenModalType(null);
  };

  return (
    <ModalContext.Provider value={{ openModalType, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};
